import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Button, Container, Row, Col, Form, Modal, Table, Stack, TabPane, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cargoService from "../../services/cargo.service";

const initialCargo = {
    nombre: "",
    tipo: ""
}

const Cargo = () => {
    const [cargo,setCargo] = useState(initialCargo);
    const [cargos, setCargos] = useState([]);

    useEffect(()=>{
        retreiveCargos();
    }, []);

    function retreiveCargos() {
        cargoService.getAll()
        .then(cc=>{
            console.log(cc);
            setCargos(cc.data);
        })
        .catch(err=>{
            console.error(err);
        });
    }

    const handleChangeCC = (valor, nombre) => {
        setCargo({...cargo, [nombre]:valor});
    }

    const ingresarCC = () => {
        if(cargo.tipo === "") {
            alert("Debe seleccionar tipo");
            return;
        }
        if(cargo.nombre === "") {
            alert("Campo nombre es requerido");
            return;
        }
        cargoService.create(cargo)
        .then(cn=>{
            console.log(cn);
            toast.info("Cargo ingresado correctamente!",{
                position:"top-center",
                autoClose: 2000
            });
            retreiveCargos();
        })
        .catch(err=>{
            console.error(err);
        });
    }

    function buttonFormat(cell, row) {
        return <Button variant="danger" onClick={() => eliminarCC(row.id)}><FontAwesomeIcon icon="fa-solid fa-trash-can" /></Button>;
    }

    const eliminarCC = (id) => {
        if (window.confirm("Esta seguro de eliminar el Cargo?")) {
            cargoService.eliminarCargo(id)
            .then(data=>{
                toast.info(data.data.message,{
                    position: "top-center",
                    autoClose: 2000
                });
                retreiveCargos();
            })
            .catch(err=>{
                console.error(err);
            });
        }
    }

    return (
        <Container>
            <Row>
                <Col sm={4}>
                    <h4>Ingresar Cargos</h4>
                    <Form.Group>
                        <Form.Label>Nombre:</Form.Label>
                        <Form.Control type="text" onChange={(e)=>handleChangeCC(e.target.value, "nombre")} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Tipo:</Form.Label>
                        <Form.Select onChange={(e)=>handleChangeCC(e.target.value, "tipo")}>
                            <option value="">Seleccione Tipo ...</option>
                            <option value="DIRECTO">DIRECTO</option>
                            <option value="INDIRECTO">INDIRECTO</option>
                            <option value="DIRECTO-SUPERVISIÓN">DIRECTO-SUPERVISIÓN</option>
                            <option value="DIRECTO-OPERADOR">DIRECTO-OPERADOR</option>
                        </Form.Select>
                    </Form.Group>
                    <div className="mt-3"></div>
                    <Button variant="primary" onClick={ingresarCC}>Agregar</Button>
                </Col>
                <Col>
                    <h4>Lista de Cargos</h4>
                    <BootstrapTable data={cargos}>
                        <TableHeaderColumn dataField="id" isKey hidden>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField="nombre">Nombre</TableHeaderColumn>
                        <TableHeaderColumn dataField="tipo">Tipo</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={buttonFormat} width="15%" tdStyle={{ textAlign:"center", whiteSpace: 'normal', wordWrap: 'break-word' }}>Eliminar</TableHeaderColumn>
                    </BootstrapTable>
                </Col>
            </Row>
        </Container>
    )
}

export default Cargo;